<template>
  <div class="app-container">
    <router-view/>
  </div>
</template>

<script setup>
import Landing from './views/Landing.vue';

// export default {
//   components : {Landing}
// }
</script>

<style lang="scss" scoped>
.app-container {
  /* Safe area insets para dispositivos con notch/cámara */
  padding-top: env(safe-area-inset-top);
  padding-left: env(safe-area-inset-left);
  padding-right: env(safe-area-inset-right);
  /* No aplicar bottom aquí porque la navegación móvil ya lo maneja */
  width: 100%;
  min-height: 100vh;
  box-sizing: border-box;
}

/* En móvil, reservar espacio para la navegación inferior */
@media (max-width: 991.98px) {
  .app-container {
    padding-bottom: calc(70px + env(safe-area-inset-bottom));
  }
}
</style>
